import React from "react";
import "./com_5.css";
import { Target, Eye, Users } from "lucide-react"; // for icons

const WhyChoose = () => {
  return (
    <section className="whychoose-section">
      <div className="whychoose-container">
        <p className="whychoose-subtitle">WHY?</p>
        <h2 className="whychoose-title">WHY CHOOSE BOODOO</h2>

        <div className="whychoose-grid">
          <div className="whychoose-card">
            <Target className="whychoose-icon" />
            <h3>GREAT EXPERIENCE</h3>
            <p>
              Lorem ipsum dolor sit amet consectetur. Pellentesque nascetur sed
              tellus ut vehicula eu consec.
            </p>
          </div>

          <div className="whychoose-card">
            <Eye className="whychoose-icon" />
            <h3>DATA PRIVACY</h3>
            <p>
              Lorem ipsum dolor sit amet consectetur. Pellentesque nascetur sed
              tellus ut vehicula eu consec.
            </p>
          </div>

          <div className="whychoose-card">
            <Users className="whychoose-icon" />
            <h3>BEST CUSTOMER SUPPORT</h3>
            <p>
              Lorem ipsum dolor sit amet consectetur. Pellentesque nascetur sed
              tellus ut vehicula eu consec.
            </p>
          </div>
        </div>
      </div>
      <div className="whychoose-line"></div>
    </section>
  );
};

export default WhyChoose;
